import groupedRequestDetailsStore from "../store/store";
import { IOpenShiftEntity } from "sh-models";
import { mutatorAction } from "satcheljs";

export default mutatorAction('SET_OPEN_SHIFT_IN_STORE', function setOpenShiftInStore(openShift: IOpenShiftEntity) {
    if (groupedRequestDetailsStore) {
        groupedRequestDetailsStore.openShift = openShift;
    }
});